export default "__VITE_ASSET__U2PwZeHd__"